module.exports = __webpack_public_path__ + "media/images/front/icon_trophy_beginner-d375909b871d329074f229e10fc73f08.png";